import { COMPONENT_RECYCLERVIEW_LIST } from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce Customizable List Layout Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function(name = "Customizable List Layout", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_RECYCLERVIEW_LIST,
    children: children
  };
  return Object.assign(obj, common);
}
